<div class="d-flex flex-row justify-content-center align-items-center">
  <div class="signup">
    <div class="signup__upper-content">
      <div class="signup__label">{{ 'INFO.SIGN_UP' | translate }}</div>
      <div class="signup__links links ms-2">
        <p class="links__text">{{ 'INFO.NOTE_001' | translate }}</p>
        <a class="links__button" routerLink="/login">{{ 'INFO.SIGN_IN' | translate }}</a>
      </div>
    </div>

    <form class="signup__main-content" [formGroup]="registrationForm" (ngSubmit)="onRegistrationFormSubmit()"
      id="login-form" novalidate>
      <div class="signup__wrapper">
        <div class="headline p-0">
        </div>
        <div class="personal-info mt-2">
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-row label-info">
                <label class="w-100" for="email">{{ 'LOGIN.EMAIL' | translate }} *</label>
                <div *ngIf="registrationFormControls.email?.invalid && (registrationFormControls.email?.dirty || registrationFormControls.email?.touched)"
                  class="alert">
                  <div *ngIf="registrationFormControls.email?.errors?.['required']">
                    <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                      pTooltip="{{ 'INFO.EMAIL_REQUIRED' | translate }}" tooltipPosition="top"></i>
                  </div>
                  <div *ngIf="registrationFormControls.email?.errors?.['pattern']">
                    <i class="pi pi-info-circle me-1 pt-2 error-icon" pTooltip="{{ 'INFO.INVALID_EMAIL' | translate }}"
                      tooltipPosition="top"></i>
                  </div>
                </div>
              </div>
              <input type="email" id="email" formControlName="email" name="email"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}">
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-row label-info">
                <label class="w-100" for="firstName">{{ 'LOGIN.FIRSTNAME' | translate }} *</label>
                <div *ngIf="registrationFormControls.firstName?.invalid && (registrationFormControls.firstName?.dirty || registrationFormControls.firstName?.touched)"
                  class="alert">
                  <div *ngIf="registrationFormControls.firstName?.errors?.['required']">
                    <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                      pTooltip="{{ 'INFO.FNAME_REQUIRED' | translate }}" tooltipPosition="top"></i>
                  </div>
                  <div *ngIf="registrationFormControls.firstName?.errors?.['maxlength'] || registrationFormControls.firstName?.errors?.['pattern']">
                    <i class="pi pi-info-circle me-1 pt-2 error-icon" pTooltip="{{ 'INFO.FNAME_PATTERN' | translate }}"
                      tooltipPosition="top"></i>
                  </div>
                </div>
              </div>
              <input type="text" id="firstName" formControlName="firstName" name="firstName"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" required>
            </div>
            <div class="col-12">
              <div class="d-flex flex-row label-info">
                <label class="w-100" for="lastName">{{ 'LOGIN.LASTNAME' | translate }} *</label>
                <div *ngIf="registrationFormControls.lastName?.invalid && (registrationFormControls.lastName?.dirty || registrationFormControls.lastName?.touched)"
                  class="alert">
                  <div *ngIf="registrationFormControls.lastName?.errors?.['required']">
                    <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                      pTooltip="{{ 'INFO.LNAME_REQUIRED' | translate }}" tooltipPosition="top"></i>
                  </div>
                  <div *ngIf="registrationFormControls.lastName?.errors?.['maxlength'] || registrationFormControls.lastName?.errors?.['pattern']">
                    <i class="pi pi-info-circle me-1 pt-2 error-icon" pTooltip="{{ 'INFO.FNAME_PATTERN' | translate }}"
                      tooltipPosition="top"></i>
                  </div>
                </div>
              </div>
              <input type="text" id="lastName" formControlName="lastName" name="lastName"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}">
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-row label-info">
                <label class="w-100" for="password">{{ 'LOGIN.PASSWORD' | translate }} *</label>
                <div *ngIf="registrationFormControls.password?.invalid && (registrationFormControls.password?.dirty || registrationFormControls.password?.touched)"
                class="alert">
                <div *ngIf="registrationFormControls.password?.errors?.['required']">
                  <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                    pTooltip="{{ 'INFO.PASSWORD_REQUIRED' | translate }}" tooltipPosition="top"></i>
                </div>
                <div *ngIf="registrationFormControls.password?.errors?.['minlength'] || registrationFormControls.password?.errors?.['pattern']">
                  <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                    pTooltip="{{ 'INFO.PASSWORD_PATTERN' | translate }}" tooltipPosition="top"></i>
                </div>
              </div>
              </div>
              <input type="password" id="password" formControlName="password" name="password"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}" autocomplete>
            </div>
            <div class="col-12">
              <div class="d-flex flex-row label-info">
                <label class="w-100" for="confirmPassword">{{ 'LOGIN.CONFIRM_PASSWORD' | translate }} *</label>
                
                <div *ngIf="registrationFormControls.confirmPassword?.invalid && (registrationFormControls.confirmPassword?.dirty || registrationFormControls.confirmPassword?.touched)"
                class="alert">
                <div *ngIf="registrationFormControls.confirmPassword?.errors?.['required']">
                  <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                    pTooltip="{{ 'INFO.PASSWORD_CONFIRM' | translate }}" tooltipPosition="top"></i>
                </div>
                <div *ngIf="registrationFormControls.confirmPassword.errors?.mustMatch">
                  <i class="pi pi-info-circle  me-1 pt-2 error-icon"
                    pTooltip="{{ 'INFO.PASSWORD_MATCH' | translate }}" tooltipPosition="top"></i>
                </div>
              </div>
              </div>
              <input type="password" id="confirmPassword" formControlName="confirmPassword" name="confirmPassword"
                placeholder="{{ 'INFO.PLACEHOLDER' | translate }}">
            </div>
          </div>

          <div class="row">
            <div class="col-12 d-inline-flex">
              <label style="width: auto;" class="terms-label">
                <input type="checkbox" formControlName="termsOfConditionsAccepted" id="acceptTerms">
                <span class="checkmark"></span>
              </label>
              <label style="width: auto;" class="terms-label"> {{ 'INFO.AGREE' | translate }} <span
                  (click)="openTermsAndConditions()">{{
                  'INFO.TERMS' | translate }}</span>
              </label>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button [disabled]="!registrationForm.valid " class="register-button button full">{{ 'INFO.REGISTER' |
                translate }}</button>
              <mat-spinner *ngIf="loadingPage" class="sign-in-spinner"></mat-spinner>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <p class="info-note">{{ 'INFO.NOTE_004' | translate }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button (click)="registerWithFacebook()"
                class="btn-social-login d-flex justify-content-center align-items-center" type="button"><i
                  class="pi pi-facebook me-2"></i>{{ 'INFO.SIGNUP_FB' | translate }}</button>
            </div>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>